import qs from 'qs'
import isEmpty from './isEmpty'

export default function parseQueryString (key, isHistoryMode, del, replace) {
  if (typeof key === 'object') {
    isHistoryMode = key.mode === 'history'
    del = key.del
    //replace = key.replace
    key = key.key // 必须最后赋值
  }

  let obj, search = window.location.search, hash = window.location.hash

  function parseSearch () {
    return qs.parse(search, { ignoreQueryPrefix: true })
  }

  function parseHash () {
    const questionMarkIndex = hash.indexOf('?')
    if (questionMarkIndex === -1) {
      return obj = {}
    }
    obj = qs.parse(hash.substring(questionMarkIndex), { ignoreQueryPrefix: true })
    if (search.includes('code=')) {
      obj.code = parseSearch().code || obj.code //如果search中没拿到code 则沿用hash中的code
    }
  }

  isHistoryMode ? obj = parseSearch() : parseHash()

  if (isEmpty(key)) {
    return obj || {}
  } else {
    if (del) {
      if (isHistoryMode || key === 'code') {
        //删除会导致页面刷新 需要判断存在才删除 避免死循环
        if (search.includes(`${key}=`)) {
          const newSearch = search.replace(`${key}=${obj[key] || ''}`, '')
          //if (replace === false) {
            window.location.search = newSearch
          //} else {
          //  window.location.replace(window.location.href.replace(window.location.search, newSearch))
          //}
        }
      }
      if (!isHistoryMode || key === 'code') {
        //删除会导致页面刷新 需要判断存在才删除 避免死循环
        if (hash.includes(`${key}=`)) {
          const newHash = hash.replace(`${key}=${obj[key] || ''}`, '')
          //if (replace === false) {
            window.location.hash = newHash
          //} else {
          //  window.location.replace(window.location.href.replace(window.location.hash, newHash))
          //}
        }
      }
    }
    return obj[key] || ''
  }
}
